const MapCountry = ({ country, countryInfo, nameSuffix, colorTheme, className = '' }) => {
  return (
    <div
      className={`h-[48px] px-[10px] py-[6px] flex flex-col items-start justify-start w-[calc(33.333333333%-6px)] rounded-[6px] ${colorTheme.block} ${className}`}
    >
      <div className={`min-h-[18px] w-full flex items-center !mb-1 ${colorTheme.text}`}>
        <span className="text-xs font-semibold font-Inter">
          {countryInfo.printable_name}{' '}
          <span className="font-medium">
            - {country.students.length} Student{country.students.length > 1 ? 's' : ''}
          </span>
        </span>

        {nameSuffix}

        <span className="ml-auto text-[10px] font-semibold font-Inter">
          {Number(country.percentage.toFixed(3))}%
        </span>
      </div>

      <div
        className={`rounded-[2px] h-[8px] w-full ${colorTheme.progressBar.outer} rounded-sm overflow-hidden`}
      >
        <div
          className={`rounded-[2px] h-full ${colorTheme.progressBar.inner}`}
          style={{ width: `${country.percentage}%` }}
        />
      </div>
    </div>
  )
}

export default MapCountry
